























export default {
  name: 'UsersTable',
  data: () => ({
    headers: [
      {
        text: 'Nom d\'utilisateur',
        align: 'left',
        sortable: false,
        value: 'name',
      },
      { text: 'Version utilisée', value: 'version' },
      { text: 'Nombre d\'appels API', value: 'nbAPICalls' },
      { text: 'Dernier résultat', value: 'lastCode' },
    ],
    values: [
      {
        name: 'Redblueflame',
        version: 'SkraperV0.1',
        nbAPICalls: 245100,
        lastCode: 400,
      },
      {
        name: 'MarbleMad',
        version: 'SkraperV1.2',
        nbAPICalls: 25100,
        lastCode: 200,
      },
    ],
  }),
};
